var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"event-detail"},[_c('v-row',{attrs:{"gutters":3,"pa-2":""}},[_c('v-col',{staticStyle:{"max-width":"300px !important"}},[_c('div',{staticClass:"sidebar"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Tickets')))])])]),_c('v-col',[_c('v-card',{staticClass:"codox-card"},[_c('codox',{attrs:{"event-id":_vm.id,"doc-id":_vm.id}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }